// extracted by mini-css-extract-plugin
module.exports = {"root":"FeaturedItem_root__koq6E","content":"FeaturedItem_content__xCCOP","title":"FeaturedItem_title__I8PzM","link":"FeaturedItem_link__iEf67"};